import { applyMiddleware } from "redux";

import { autoRehydrate } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import bagMiddleware from "./middleware/bag";
import bodyScrollMiddleware from "./middleware/bodyScroll";
import actionDeferralMiddleware from "./middleware/actionDeferral";
import thunk from "redux-thunk";
import * as api from "../../api";

export default () =>
  composeWithDevTools({ name: "SiteChrome" })(
    applyMiddleware(
      actionDeferralMiddleware, //must go first!
      thunk.withExtraArgument({
        api,
        get identity() {
          return window.asos.sdk.identity;
        }
      }),
      bagMiddleware,
      bodyScrollMiddleware
    ),
    autoRehydrate()
  );



// WEBPACK FOOTER //
// ./template/state/enhancers.js